export const PACKAGE_LIST_VIEW_ID = 'packagelist';
export const TASK_VIEW_ID = 'task';
export const SKILL_DELIVERY_VIEW_ID = 'skilldelivery';
export const HOLDING_VIEW_ID = 'holding';
export const NEW_USER_VIEW_ID = 'new-user';
export const PASSWORD_REVEAL_VIEW_ID = 'password-reveal';
export const USERNAME_REVEAL = 'username-reveal';
export const CHOOSE_PASSWORD = 'choose-password';
export const CONFIRM_DETAILS = 'confirm-details';
export const INFO_BOX = 'info-box';
export const ALREADY_SET_UP = 'already-set-up';
export const PASSWORD_RESET_REQUESTED = 'password-reset-requested';
export const REVISION_VIEW_ID = 'revision';
